/** Gathering calm (fx 'calm', 'breath'): a ring and a rune circle round the caster. */
import { registerFx } from './registry';

registerFx(['calm', 'breath'], (host) => ({
  skill: ({ sx, sy }) => {
    host.fx.push({ type: 'ring', x: sx, y: sy, t: 0, life: 0.6, r: 26, col: '255,220,120' });
    host.fx.push({ type: 'sigil', x: sx, y: sy, t: 0, life: 1, r: 22, col: '255,220,120' });
    host.sfx.heal();
  },
}));
